import { CaptchaType } from '@/domain/enums/captcha-type';
import globals from '@/utils/globals';
import { computed, Ref, ref } from 'vue';
import { ICaptchaInstance } from '@/domain/services/captcha-service';

declare const CAPTCHA_SITE_KEY: string;
declare global {
	interface Window {
		turnstile: {
			render: (widgetId: string, options: any) => void;
			remove: (widgetId: string) => void;
			reset: (widgetId: string) => void;
		};
	}
}

export class Captcha {
	public showErrorMessage = ref(false);
	public hash: Ref<string | null> = ref(null);

	constructor(private readonly captcha: ICaptchaInstance = globals.globalStoreCaptcha) {
		this.hash.value = this.generateRandomHash();
	}

	public widgetSelector = computed((): string => {
		return `#Captcha-${this.hash.value}`;
	});

	public widgetId = computed((): string => {
		return `Captcha-${this.hash.value}`;
	});

	private generateRandomHash(): string {
		const randomHash = Math.random().toString(36).substring(2, 15);
		return randomHash;
	}

	public mounted(): void {
		globals.eventBus.on('resetCaptcha', () => this.resetCaptcha());
		if (this.captcha.captcha?.type === CaptchaType.BYPASS) return;

		void this.renderTurnstile();
	}

	public beforeUnmount(): void {
		if (!window.turnstile) return;

		window.turnstile.remove(this.widgetSelector.value);
	}
	public async renderTurnstile(): Promise<void> {
		await this.captcha.loadCloudFlareCaptcha();

		window.turnstile.render(this.widgetSelector.value, {
			sitekey: CAPTCHA_SITE_KEY,
			theme: 'light',
			callback: (token: string) => this.storeCaptcha(token),
			'timeout-callback': () => this.handleError(),
			'error-callback': () => this.handleError(),
		});
	}

	private handleError(): void {
		this.showErrorMessage.value = true;
		this.resetCaptcha();
	}

	private storeCaptcha(token: string): void {
		this.showErrorMessage.value = false;
		this.captcha.saveCaptcha({
			type: CaptchaType.CAPTCHA,
			token,
		});
	}

	private resetCaptcha(): void {
		this.captcha.saveCaptcha(null);
		window.turnstile.reset(this.widgetSelector.value);
	}
}
